"use client";

import React from "react";
import { CircleCheck } from "lucide-react";
export default function NorthwoodsAuthority() {
  return <section id="northwoods-authority" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px] pointer-events-none"></div>

      <div className="container mx-auto px-4 relative z-10">
        {}
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-4">
            <CircleCheck className="text-primary size-6" />
            <span className="text-primary font-bold uppercase tracking-widest text-sm">Project Reviews</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tight mb-6 text-foreground">
            The Standard in <br className="hidden md:block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-primary/70">residential and commercial excavating</span>
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl leading-relaxed">
            Trusted by property owners and premier builders across the Northwoods for 40 years. We don't just move earth; we engineer peace of mind through reliability for our clients.
          </p>
        </div>

        {}
        <div className="mx-auto px-4 backdrop-blur-sm bg-card/30 border border-border/50 p-1 md:p-2 max-w-[800px]">
          <div className="relative w-full h-[1000px] overflow-hidden">
            <iframe src="https://client.housecallpro.com/reviews/widget/cee8868f-aba5-4bc6-bfb0-c663fbe42973" className="w-full h-full border-0" title="HouseCall Pro Reviews" loading="lazy" width="1000" height="1000" />
          </div>
        </div>
      </div>
    </section>;
}